import APIConstants from "./APIConstants";
import APIService from "./APIService";
import DebugService from "./DebugService";

/**
 * @description Contact Us Api Service
 */
const ContactUsApiService = {
  /**
   * Contact us form submit
   * @param {*} data 
   * @returns 
   */
  submit: async (data) => {
    try {
      return await APIService.post(APIConstants.ENDPOINT_CONTACT_US, data)
    } catch (err) {
      DebugService.error('Contact Us Api Service: Contact Us Api Service: Caught error while submitting', err)
    }
  },

  /**
   * Get all contact us data list
   * @param {*} data 
   * @returns 
   */
  getList: async (data) => {
    try {
      let endpoint = APIConstants.ENDPOINT_CONTACT_US_LIST

      if (data !== undefined && data['filters'] !== undefined && data['filters']['status'] !== undefined) {
        endpoint = `${endpoint}?status=${data['filters']['status']}`
      }

      return await APIService.get(endpoint)
    } catch (err) {
      DebugService.error('Contact Us Api Service: Contact Us Api Service: Caught error while fetching', err)
    }
  },

  /**
   * Mark the requested contact us data as "Completed"
   * @param {*} data 
   * @param {*} id 
   * @returns 
   */
  update: async (data, id) => {
    try {
      return await APIService.put(`${APIConstants.ENDPOINT_CONTACT_US}/${id}`, data)
    } catch (err) {
      DebugService.error('Contact Us Api Service: Contact Us Api Service: Caught error while updating', data, err)
    }
  },
};

export default ContactUsApiService;
